module.exports = __WEBPACK_EXTERNAL_MODULE_OMN4__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = OMN4
// module chunks = 78